import * as Yup from "yup";

export const AddFoulInitialState = {
  team: "",
  time: "",
  player: "",
  card: "",
  description: "",
};

export const AddFoulValidationSchema = Yup.object({
  team: Yup.string().required("Este campo es requerido"),
  time: Yup.string().required("Este campo es requerido"),
  player: Yup.string().required("Este campo es requerido"),
  card: Yup.string().required("Este campo es requerido"),
  description: Yup.string().required("Este campo es requerido"),
});
